<script lang="ts">
import type { AvatarFallbackProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import type { AvatarSize } from './Avatar.vue'

export interface AvatarFallbackPropsWithClass extends AvatarFallbackProps {
  class?: HTMLAttributes['class']
}

const textSizes: Record<AvatarSize, string> = {
  '2xs': 'text-2xs',
  xs: 'text-2xs',
  sm: 'text-2xs',
  md: 'text-xs',
  lg: 'text-lg',
}
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import { AvatarFallback, useForwardProps } from 'reka-ui'
import { computed, inject } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { AVATAR_KEY } from './Avatar.vue'

const props = defineProps<AvatarFallbackPropsWithClass>()

const delegatedProps = reactiveOmit(props, 'class')
const forwarded = useForwardProps(delegatedProps)

const avatar = inject(AVATAR_KEY, null)
const textSize = computed(() => textSizes[avatar?.size.value ?? 'sm'])
</script>

<template>
  <AvatarFallback
    data-slot="avatar-fallback"
    v-bind="forwarded"
    :class="
      cn(
        'flex size-full items-center justify-center rounded-full bg-secondary-subtle text-primal',
        textSize,
        props.class,
      )
    "
  >
    <slot />
  </AvatarFallback>
</template>
